export interface QaBuildEnvironment {
  [key: string]: string | boolean | undefined;
  VITE_QA_ENVIRONMENT?: string;
  VITE_AUTH0_DOMAIN?: string;
  VITE_AUTH0_CLIENT_ID?: string;
  VITE_API_URL?: string;
  VITE_AUTH0_CALLBACK_URL?: string;
  VITE_AUTH0_AUDIENCE?: string;
}

export function validateQaEnvironment(
  env: QaBuildEnvironment,
  currentOrigin?: string
) {
  const environment = env.VITE_QA_ENVIRONMENT;
  if (!environment) {
    if (
      [env.VITE_API_URL, env.VITE_AUTH0_CALLBACK_URL].some(
        (value) =>
          value?.includes("-release-qa-") ||
          value?.includes("-qa-slot-") ||
          value?.includes(".qa.trypreview.app")
      )
    ) {
      throw new Error("VITE_QA_ENVIRONMENT is required for QA builds.");
    }
    return undefined;
  }
  const match = /^release-qa-(\d{4})(\d{2})(\d{2})-(\d{2,})$/.exec(environment);
  const parallel = /^qa-[0-9a-f]{32}$/.test(environment);
  const template = environment === "qa-template";
  if (
    !parallel &&
    !template &&
    environment !== "qa-slot-01" &&
    (!match ||
      Number(match[4]) < 1 ||
      new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`)
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "") !== `${match[1]}${match[2]}${match[3]}`)
  ) {
    throw new Error(
      "VITE_QA_ENVIRONMENT must identify one reserved QA attempt."
    );
  }
  if (!env.VITE_AUTH0_DOMAIN || !env.VITE_AUTH0_CLIENT_ID) {
    throw new Error("QA authentication client and domain are required.");
  }
  const label = template ? "template" : environment;
  const customerOrigin =
    parallel || template
      ? `https://${label}.customer.qa.trypreview.app`
      : `https://ezx-customer-${environment}.trypreview.app`;
  const apiOrigin =
    parallel || template
      ? `https://${label}.server.qa.trypreview.app`
      : `https://ezx-server-${environment}.trypreview.app`;
  const ordinaryPreview =
    (environment === "qa-slot-01" || parallel || template) &&
    env.VITE_AUTH0_DOMAIN === "tooez-preview.ca.auth0.com" &&
    env.VITE_AUTH0_AUDIENCE === "https://api.tooez.ca";
  if (
    (template && currentOrigin !== undefined) ||
    ((parallel || template) && !ordinaryPreview) ||
    env.VITE_AUTH0_CALLBACK_URL !== customerOrigin ||
    env.VITE_API_URL !== apiOrigin ||
    (env.VITE_AUTH0_AUDIENCE !== apiOrigin && !ordinaryPreview) ||
    (currentOrigin !== undefined && currentOrigin !== customerOrigin)
  ) {
    throw new Error(
      "QA origin, API, callback and audience must share one attempt."
    );
  }
  return { environment, customerOrigin, apiOrigin };
}
